<div class="splash">
    <div class="row align-items-center">
        <div class="col-sm-5 col-md-4 offset-md-2 col-lg-3 offset-lg-2">
           
            <div class="row">
                <div class="col">
                    <img src="images/deloitte.svg" alt="Deloitte" class="splash__logo mb-3" />        
                </div>
            </div>

            <div class="row mb-4 pt-4">
                <div class="col">
                    <p class="splash__title">
                        Successfully signed out
                    </p>
                    <p class="text-muted textBody--md mb-4">You have been signed out of the portal.</p>
                    <p class="text-muted">Click here to <a [routerLink]="['/splash']" (click)="navigateToSignIn()"> Sign In</a></p>  
                </div>               
            </div>

            <div class="row pt-0">

                <div class="col">
                     <small> Need assistance? | <a href="mailto:gtls@deloitte.com?subject= Tax CMS - General Enquiry">Contact us</a></small>
                </div>
            </div>
        </div>
        
        <div class="col-sm-7 col-md-6">       
            <div class="splash__image">
               <img src="/images/globe.jpg"/> 
            </div>
        </div>
    </div>
</div>



